export class EmailUtils {
	// just make sure there is one @ and no spaces. Backend uses more reliable validation
	static validate(email: string): boolean {
		let emailPattern = /^[^\s@]+@[^\s@]+$/;
		return new RegExp(emailPattern).test(email);
	}
}
